import Vue from "vue";
// @ts-ignore
import App from "./App.vue";
import router from "./router";
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
	config: { id: "UA-173926484-1" }
});

import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, {
	siteKey: '6LfHHLgZAAAAAGO79JvFAvJ1t388_EqStQDi92gK',
	loaderOptions: {
		useRecaptchaNet: true,
		autoHideBadge: true
	}
})

import CountryFlag from 'vue-country-flag'
Vue.component('country-flag', CountryFlag)

import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios, axios);

Vue.config.productionTip = false;

new Vue({
	router,
	render: h => h(App)
}).$mount("#app");
